var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-query"},[(_vm.brand == 'COTTI')?_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/redirect/img_waiting.png"),"alt":""}}):(_vm.brand == '茶猫')?_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/redirect/teacat_img_waiting.png"),"alt":""}}):_vm._e(),_c('div',{staticClass:"title"},[_vm._v("稍等片刻，福利开启中")])])
}
var staticRenderFns = []

export { render, staticRenderFns }